<div class="d-flex w-100" style="height: 400px">
	<div class="mx-auto my-auto display-6">
		<div class="animation-blur-out animate-duration-5s animate-count-infinite">Loading dashboard...</div>
	</div>
</div>
